<template>
  <div id="app">
    <div>
      <confirm ref="confirm"></confirm>
      <loader v-model=statusval.loading></loader>
      <arksnackbar v-model="statusval"></arksnackbar>
    </div>

    <v-app id="inspire" light>
      <v-card color="grey lighten-2" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{title}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <!--
                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html İndir</v-list-tile-title>
                  </v-list-tile>
                  -->
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-card color="grey lighten-1" flat>
              <v-layout row wrap>
                <v-flex xs12 sm6 md2>
                  <v-layout align-center justify-start row fill-height>
                    <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data" v-model="valid"
                      lazy-validation>
                      <input hidden type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()" />
                    </v-form>
                    <v-btn :loading="false" :disabled="false" color="info" dark @click="addFiles()">
                      <v-icon color="white" left>attach_file</v-icon>Aktarım Dosyası Seçiniz
                    </v-btn>
                    <div v-show="load2">
                      <v-btn small="" fab @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="btnSubmitFiles()"
                        color="info" dark>
                        <v-icon>redo</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>Seçilenleri Aktar</span>
                      </v-tooltip>
                    </div>
                    <!-- <div v-if="status.loading">
                      <v-layout>
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                      </v-layout>
                    </div> -->
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm12 md4>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-alert :value="true" :color="alertcolor" icon="check_circle" outline>
                    {{alertmessage}}
                  </v-alert>
                </v-flex>
              </v-layout>
            </v-card>
          </v-container>






          <!-- <div class="large-12 medium-12 small-12 cell">
          <template v-for="(file, key) in files">
            <v-chip :key="file.key" close @input="removeFile(key)">
              <strong>{{ file.name }}</strong>&nbsp;
            </v-chip>
          </template>
        </div> -->

          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12 sm6 md6>
                <v-toolbar size="120px" dark color="info">
                  <v-toolbar-title>Aktarılan Biletler</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
                </v-toolbar>

                <v-card>
                  <v-data-table :headers="headers" :rows-per-page-items="[20,500]" :items="itemsok" :search="search3">
                    <template slot="items" slot-scope="props">
                      <tr item>
                        <td class="text-xs-left">{{ props.item.biletNo }}</td>
                        <td class="text-xs-left">{{ props.item.aciklama }}</td>
                        <v-btn icon class="mx-0" @click="git(props.item)">
                          <v-icon color="teal">search</v-icon>
                        </v-btn>
                      </tr>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">Aradığınız "{{ search3 }}"
                      kelimesi ile ilgili herhangi bir kayıt bulunamadı..</v-alert>
                  </v-data-table>
                </v-card>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-toolbar size="120px" dark color="red">
                  <v-toolbar-title>Aktarılamayan Biletler</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field flat="" solo-inverted="" hide-details v-model="search4" label="Ara" append-icon="search"></v-text-field>
                </v-toolbar>
                <v-card>
                  <v-data-table :headers="headers" :rows-per-page-items="[20,500]" :items="itemsno" :search="search4">
                    <template slot="items" slot-scope="props">
                      <tr item>
                        <td class="text-xs-left">{{ props.item.biletNo }}</td>
                        <td class="text-xs-left">{{ props.item.aciklama }}</td>
                        <v-btn icon class="mx-0" @click="git(props.item)">
                          <v-icon color="teal">search</v-icon>
                        </v-btn>
                      </tr>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">Aradığınız "{{ search4 }}"
                      kelimesi ile ilgili herhangi bir kayıt bulunamadı..</v-alert>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
        :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
      </v-snackbar>



    </v-app>
  </div>

</template>

<script>
  import confirm from "@/components/app/coper/comp/confirm.vue";
  import loader from "@/components/app/coper/comp/loader.vue";
  import arksnackbar from "@/components/app/coper/comp/arksnackbar.vue";
  import customdialog from "@/components/app/coper/comp/customdialog.vue";

  import tool from "../../coper/tools";

  export default {
    props: ["value", "title", "status"],
    data() {
      return {
        headers: [{
            text: 'Bilet No',
            value: 'biletNo'
          },
          {
            text: 'Durum',
            value: 'aciklama'
          }

        ],
        itemsno: [],
        itemsok: [],
        alertcolor: "red",
        alertmessage: 'Henüz Dosya Seçilmedi...',

        search3: '',
        search4: '',

        files: [],
        valid: true,
        load2: false,
        load3: false,
        search3: '',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        tooltip: false,
        el: null,
      };
    },
    components: {
      confirm,
      loader,
      arksnackbar,
      customdialog
    },

    computed: {
      model: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit("input", newValue);
        }
      },
      statusval: {
        get: function () {
          if (this.status == null) {
            return tool.NewSatatus();
          } else {
            return this.status;
          }
        }
      }
    },

    watch: {
      model(val) {
        this.watchmodel(val);
      }
    },
    mounted() {
      this.el = this.$refs.fab.$el
    },

    methods: {
      watchmodel(val) {
        this.itemsok = []
        this.itemsno = []

        if (val) {

          val.forEach(element => {
            if (element.basarili) {
              this.itemsok.push(element)
              //aktarilan = aktarilan + 1
            } else {
              this.itemsno.push(element)
            }
          });

        }
      },
      handleFilesUpload() {

        this.files = []

        let uploadedFiles = this.$refs.files.files;

        if (uploadedFiles.length > 0) {
          this.alertcolor = "success";
          this.alertmessage = "Toplam " + uploadedFiles.length + " adet dosya seçildi."
          this.load2 = true;
          for (var i = 0; i < uploadedFiles.length; i++) {
            this.files.push(uploadedFiles[i]);
          }
          // this.text1 = "Toplam " + uploadedFiles.length + " dosya seçildi."
          // this.snackbar = true

        } else {
          this.alertmessage = "Henüz Dosya Seçilmedi...";
          this.alertcolor = "red";
          this.load2 = false;
        }


      },
      btnSubmitFiles() {

        this.$refs.confirm
          .open("Bilet Aktarımı", this.title + " Dosyaları Aktarılsın mı?", {
            color: "red",
          })
          .then(confirm => {
            if (confirm == true) {
              this.$emit("submitfile", this.files);
            }
          });

      },

      removeFile(key) {
        this.files.splice(key, 1);
      },
      removeAllFiles() {
        this.$refs.confirm
          .open("Dosya Sil", "Dosyalar silinsin mi?", {
            color: "red",
          })
          .then(confirm => {
            if (confirm == true) {
              this.files = [];
            }
          });

      },

      addFiles() {
        this.$refs.files.click();
      },

      load1() {
        return (this.files.length <= 0);
      },
      git: git
    },

  };

  function git(v) {
    var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + v.bilet.HavayoluKodu + '&biletno=' + v.biletNo + '&ucustipi=' +
      v.bilet.UcusTipi
    window.open(url, '_blank')
  }
</script>